import React, { FunctionComponent } from 'react';
import { ActivityType, Outcome, RuleResult } from '../types';
import UserInputTable from './UserInputTable';
import RuleChecksTable from './RulesCheckTable';
import { MacScrollbar } from 'mac-scrollbar';
import styled from 'styled-components';
import { formatDate } from '../utils/timeUtils';
import ActivityFeed from './ActivityFeed';
import { useLabelContext } from '../contexts/LabelContext';

const Scrollbar = styled(MacScrollbar)`
    flex: 1; /* Take up remaining space */
    overflow-y: auto; /* Enable scrolling */
    display: flex;
    flex-direction: column;
`;

const AssetDetailsInformation: FunctionComponent = () => {
    const {
        state: { labelDetailed, activities },
    } = useLabelContext();

    function getOutcomeOrder(outcome: Outcome) {
        const order = {
            [Outcome.FAIL]: 1,
            [Outcome.WARNING]: 2,
            [Outcome.PASS]: 3,
        };
        return order[outcome] || 4; // default order for unknown outcomes
    }

    const compareRules = (a: RuleResult, b: RuleResult) => {
        // Compare by 'outcome' first
        if (getOutcomeOrder(a.outcome) < getOutcomeOrder(b.outcome)) {
            return -1;
        }
        if (getOutcomeOrder(a.outcome) > getOutcomeOrder(b.outcome)) {
            return 1;
        }
        return 0;
        // return b.conf - a.conf;
    };

    const ruleResultsOrdered = labelDetailed.rule_results.sort(compareRules);

    const failedRules = ruleResultsOrdered.filter(
        (rule) =>
            rule.outcome === Outcome.WARNING || rule.outcome === Outcome.FAIL,
    );
    const rulesFlagged = failedRules.length;
    const rulesPassed = ruleResultsOrdered.length - rulesFlagged;
    const totalRules = rulesPassed + rulesFlagged;

    const message =
        rulesFlagged === 0
            ? `has passed all ${totalRules} rules`
            : `failed ${rulesFlagged}/${totalRules} rules`;

    const failedRulesList = failedRules
        .map((rule) => rule.display_name)
        .join(', ');

    // If the asset has passed all rules, exclude the second sentence
    const hasFailedRules = rulesFlagged > 0;

    const approvalStatusChanged = activities.some(
        (activity) => activity.activity_type === ActivityType.STATUS_CHANGE,
    );
    console.log(approvalStatusChanged, activities);
    return (
        <>
            {/* <hr /> */}
            <Scrollbar
                trackStyle={(horizontal) => ({
                    [horizontal ? 'height' : 'width']: 0,
                    right: 0,
                    border: 0,
                })}
                thumbStyle={(horizontal) => ({
                    [horizontal ? 'height' : 'width']: 6,
                })}
            >
                <RuleChecksTable ruleResults={labelDetailed.rule_results} />
                <hr />
                <ActivityFeed activities={activities} />
                {/* <TextTable extractedText={extracedText} /> */}
                <hr />

                {/* <UserInputTable
                    assetName={labelDetailed.name}
                    country={'Unknown'}
                    uploadTime={formatDate(
                        labelDetailed.creation.timestamp,
                        true,
                    )}
                    id={labelDetailed.id.toString()}
                /> */}
                {/* <hr /> */}
            </Scrollbar>
        </>
    );
};

export default AssetDetailsInformation;
